// extracted by mini-css-extract-plugin
export var background = "ContactSection-module--background--63e06";
export var contactMessage = "ContactSection-module--contactMessage--5b6f1";
export var divider = "ContactSection-module--divider--b14b9";
export var fadeInUp = "ContactSection-module--fadeInUp--7d981";
export var formColumn = "ContactSection-module--formColumn--2b9fb";
export var imageWrapper = "ContactSection-module--imageWrapper--f3e48";
export var infoColumn = "ContactSection-module--infoColumn--c0ede";
export var leftSideMessage = "ContactSection-module--leftSideMessage--c9541";
export var list = "ContactSection-module--list--ec14d";
export var logoWrapper = "ContactSection-module--logoWrapper--90914";
export var logos = "ContactSection-module--logos--fc066";
export var message = "ContactSection-module--message--053ea";
export var root = "ContactSection-module--root--d6da5";
export var segment = "ContactSection-module--segment--380c8";